interface PageHeadingProps {
  heading: string;
  classNames?: string;
  children?: React.ReactNode;
}

export default function PageHeading({
  heading,
  classNames,
  children,
}: PageHeadingProps) {
  return (
    <div className={`mb-4 flex items-center space-x-4 ${classNames}`}>
      <h2 className="text-2xl font-[500] text-gray-800">{heading}</h2>

      {children}
    </div>
  );
}
